/* ==========================================================================
   MILFSHAKES · TARJETA DE PRODUCTO CLICABLE ENTERA
   --------------------------------------------------------------------------
   En el tema solo llevan a la ficha la imagen y el título. Con esto, un clic
   en cualquier otra parte de la tarjeta (precio, swatches decorativos, hueco
   en blanco) navega también a la ficha.

   · Dónde: solo dentro de los contenedores de data-scopes (lo pone
     snippets/mfs-mejoras.liquid; por defecto, el grid de colección).
   · A qué URL: la del enlace de la imagen. Si se ha pulsado un swatch del
     tema, ese enlace ya lleva ?variant=, así que se abre la variante elegida.
   · Delegación en document a propósito: las tarjetas también llegan por JS
     (filtros, scroll infinito) y así funcionan sin reinicializar nada.
   · Los controles propios de la tarjeta siguen haciendo lo suyo: ver IGNORE.
   · TIME FLIES TICKET: su script de product-card.liquid captura el clic antes
     y redirige él; si no lo hace, el enlace de la imagen ya apunta a Time
     Flies, así que se llega al mismo sitio.
   ========================================================================== */
(function () {
  if (window.__mfsCardFullClick) return;
  window.__mfsCardFullClick = true;

  var script = document.currentScript;
  var SCOPES = script ? (script.getAttribute('data-scopes') || '').trim() : '';
  if (!SCOPES) return;

  // Lo que ya tiene su propio comportamiento y no debe navegar
  var IGNORE = [
    'a', 'button', 'input', 'label', 'select', 'textarea', 'form', '[role="button"]',
    'product-form', 'quick-buy-modal', '.product-card__quick-buy',
    '.product-card__floating-size-selector', '.pc-arrow'
  ].join(',');

  function productUrl(event) {
    var target = event.target;
    if (!target || !target.closest) return null;

    var card = target.closest('product-card');
    if (!card || !card.closest(SCOPES)) return null;
    if (target.closest(IGNORE)) return null;

    // Si el usuario está seleccionando texto de la tarjeta, no se navega
    var selection = window.getSelection && window.getSelection();
    if (selection && !selection.isCollapsed && card.contains(selection.anchorNode)) return null;

    var link = card.querySelector('a.product-card__media') || card.querySelector('a.product-title');
    return link ? link.href : null;
  }

  function openInNewTab(url) {
    window.open(url, '_blank', 'noopener');
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;

    var url = productUrl(event);
    if (!url) return;

    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      openInNewTab(url);
    } else {
      window.location.assign(url);
    }
  });

  // Clic con la rueda: pestaña nueva, como en un enlace
  document.addEventListener('auxclick', function (event) {
    if (event.defaultPrevented || event.button !== 1) return;

    var url = productUrl(event);
    if (!url) return;

    event.preventDefault();
    openInNewTab(url);
  });
})();
